export const RESET = 'app.RESET';

export const resetApp = () => ({
    type: RESET,
});
